module.exports = __webpack_public_path__ + "img/bgpic4.9dc9f529.png";